import { useAutoAnimate } from '@formkit/auto-animate/react'
import { Button, Divider, Grid, Modal, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { BsCheck } from 'react-icons/bs'
import { ApprenticeshipFormType } from 'src/utils/sharedTypes'
import { ReactComponent as Retour } from '../../assets/Retour.svg'
import { ReactComponent as WalterLearning } from '../../assets/WalterLearning.svg'
import { ReactComponent as WalterSanteColor } from '../../assets/WalterSanteColor.svg'
import { AppointmentBooking, CallUs, Formtitle } from '../../components'
import { learningPhoneNumber } from '../../utils/constants'

type ConfirmationPropsType = {
  form: ApprenticeshipFormType
  setForm: React.Dispatch<React.SetStateAction<ApprenticeshipFormType>>
}

const Confirmation = ({ form, setForm }: ConfirmationPropsType) => {
  const theme = useTheme()
  const [animateRef] = useAutoAnimate<HTMLDivElement>()
  const [open, setOpen] = useState<boolean>(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Modal
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Grid
          container
          item
          xs={12}
          md={6}
          flexDirection="column"
          sx={{
            background: 'white',
            padding: '20px',
          }}
        >
          <AppointmentBooking form={form} setForm={setForm} />
        </Grid>
      </Modal>
      <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh', p: 2 }} ref={animateRef}>
        <Grid item xs={12} md={6} sx={{ mt: { xs: 15, md: 0 } }}>
          <Grid container justifyContent="center">
            <Grid
              item
              sx={{
                background: theme.palette.success.main,
                height: 80,
                width: 80,
                borderRadius: 40,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <BsCheck size="40px" style={{ color: 'white' }} />
            </Grid>
          </Grid>
          <Formtitle
            title={"Merci, c'est presque tout bon pour nous !"}
            subtitle={
              'Nous vous confirmons avoir bien enregistré toutes vos informations, elles vont être revues par un un responsable école qui vous appellera rapidement via le 01 76 49 80 03'
            }
            align="center"
          />
          <Typography variant="body2" textAlign="center" mb={2}>
            Pour être sur d'être sûr d'être disponible, vous pouvez réserver un créneau avec un de nos conseillers :
          </Typography>
          <Grid item container justifyContent="center">
            <Button variant="contained" onClick={() => setOpen(true)}>
              Réserver un créneau
            </Button>
          </Grid>
        </Grid>
        <Grid
          item
          container
          sx={{
            cursor: 'pointer',
            position: 'absolute',
            top: 0,
            left: 0,
            pt: 2,
            pl: { xs: 2, md: 4 },
            display: 'flex',
          }}
        >
          <Grid item container sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item>
              {location.pathname.includes('/sante') ? (
                <WalterSanteColor
                  width="162px"
                  onClick={() => {
                    window.open('https://walter-learning.com/sante', '_self')
                  }}
                />
              ) : (
                <WalterLearning
                  width="180px"
                  onClick={() => {
                    window.open('https://walter-learning.com', '_self')
                  }}
                />
              )}
            </Grid>
            <Grid item>
              <Divider orientation="vertical" sx={{ height: 40, mx: 2 }} />
            </Grid>
            <Grid
              item
              sx={{
                // flexGrow: { xs: 1, sm: 0 },
                justifyContent: 'space-between',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => {
                location.pathname.includes('/sante')
                  ? window.open('https://walter-learning.com/sante', '_self')
                  : window.open('https://walter-learning.com', '_self')
              }}
            >
              <Retour />
              <Typography variant="body1" sx={{ ml: 1 }}>
                Retour au site
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            mt: 2,
            mr: 4,
            display: { xs: 'none', md: 'block' },
          }}
        >
          <CallUs phone={learningPhoneNumber} />
        </Grid>
      </Grid>
    </>
  )
}

export default Confirmation
